import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getTheme } from '../redux/selectors/appSelectors';

const ThemeSwitcher = () => {

    const theme = useSelector(getTheme);

    useEffect(() => {
    
        // Set theme 
        const link = document.createElement('link');
        link.id = theme === 'light' ? 'light-theme' : 'dark-theme';
        link.rel = 'stylesheet';
        link.href = `/theme/${theme === 'light' ? 'style' : 'darkstyle'}.css`;
        document.head.appendChild(link);

        // Remove tag
        const id = theme === 'light' ? 'dark-theme' : 'light-theme';
        const existing = document.getElementById(id);
        if (existing) existing.remove();

    }, [theme]);

    return null;
};

export default ThemeSwitcher;